import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCategoryAvailableMenusQuerySchema } from '~/services/api/generated'

// Mirrors MenuCategoryAvailableMenusRequest rules.
export const MenuCategoryAvailableMenus = (
  _context: NoContext
): z.ZodType<z.output<typeof MenuCategoryAvailableMenusQuerySchema>> =>
  MenuCategoryAvailableMenusQuerySchema
